import { render, staticRenderFns } from "./EventLogsTable.vue?vue&type=template&id=369c4ac8"
import script from "./EventLogsTable.vue?vue&type=script&lang=ts"
export * from "./EventLogsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports